<template>
<div class="chapter">
<div class="inner_page">
<p class="ded">To Sarah Damario, whose spirit sings bright and strong.</p>
<p class="crti1">For S, as always</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?e4c94f52